/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
// import PropTypes from "prop-types"
// import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
// import Footer from "./footer"

import "./layout.css"

// import {
//   Button
// } from "@material-ui/core"

class Layout extends React.Component {

  // constructor(props) {
  //   super(props);
  //   this.handleLangChange = this.handleLangChange.bind(this);
  // }

  handleLangChange(lang, e) {
    this.props.onLangChange(lang)
  }

  // const data = useStaticQuery(graphql`
  //     query SiteTitleQuery {
  //       site {
  //         siteMetadata {
  //           title
  //         }
  //       }
  //     }
  //   `)

  render() {


    const children = this.props.children
    const lang = this.props.lang
    const locale = this.props.locale
    const dataNew = this.props.dataNew
    const siteUrl = this.props.siteUrl
    
    return (
      <>
        <Header
          siteTitle={'My Title'}
          locale={locale}
          lang={lang}
          dataNew={dataNew}
          siteUrl={siteUrl}
          onLangChange2={(lang, e) => this.handleLangChange(lang, e)}
        />
        
        {/* <p>{lang}</p><Button onClick={(e) => this.handleLangChange('arabic', e)} variant="contained" color="primary">To Ar</Button> */}
        {/* <div
          style={{
            margin: `0 auto`,
            maxWidth: 960,
          }}
        > */}
          <main>{children}</main>
        {/* </div> */}
        {/* <Footer /> */}
      </>
    )
  }
}

// Layout.propTypes = {
//   children: PropTypes.node.isRequired,
// }

export default Layout
